/**
 * Axios Configuration
 * 
 * Global axios interceptors for handling responses
 */

import axios from 'axios';

/**
 * Setup axios interceptors
 * 
 * Authentication is handled via HttpOnly cookies (withCredentials: true)
 */
export const setupAxiosInterceptors = () => {
  // Response interceptor - IP block is handled in apiClient (401 + logout + redirect to login)
  axios.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject(error)
  );
};

